import cx from 'classnames';
import { Badge } from 'components/Badge';
import { IconButton } from 'components/Buttons';
import SettingsSidebarButton from 'components/SettingsSidebar/SettingsSidebarButton';
import IconRenderer from 'components/SettingsSidebar/views/AreaIcons/IconRenderer';
import { Skeleton } from 'components/Skeleton';
import FileEarmarkPreview from 'images/icons/FileEarmarkPreview';
import { AreaEditsIcon } from 'pages/documents_v2/views/edit_area/AreaEditsIcon';
import DocumentHelper from 'pages/global/DocumentHelper';
import { CircleFill, ClockHistory, PencilSquare } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { NumberParam, useQueryParam } from 'use-query-params';

export function AreaTitle({
    area,
    baseVariant,
    blockinfo,
    document,
    isEditMode = true,
    showHistorySidebar = false,
    showHistorySidebarToggle = false,
    setShowHistorySidebar,
    selectedHistoryVersion,
    setSelectedHistoryVersion,
}) {
    const { t } = useTranslation('documents');
    const [, setSectionPreviewId] = useQueryParam('spid', NumberParam);

    const icons = area?.exportProperties?.areaIcon || [];
    const titlePrefix = area ? DocumentHelper.getPrefix(area, baseVariant.id) : undefined;

    return (
        <div className="flex-center pt-3" style={{ paddingBottom: '5rem' }}>
            <div
                style={{ fontSize: '1.25rem', minWidth: area === undefined ? 150 : undefined }}
                className="flex-center text-black font-weight-bold mr-auto"
            >
                {icons.length > 0 && (
                    <div className="flex-center mr-2">
                        <IconRenderer iconSize={20} isInsideTileRow={true} areaIcons={icons} wrapperClassName="mr-1" />
                    </div>
                )}

                <div className="mr-2">
                    {area && (area.new || area.titleEdited) && (
                        <Badge variant="warning" className="mr-2">
                            {area.new
                                ? t('documents:document.navbar.main.badges.new')
                                : t('documents:document.navbar.main.badges.titleEdited')}
                        </Badge>
                    )}

                    {titlePrefix && <span className="mr-2 small font-weight-normal">{titlePrefix}</span>}
                    {area ? <span className="mr-1">{area.title}</span> : <Skeleton />}

                    {isEditMode && area && (
                        <SettingsSidebarButton
                            context={{
                                entity: {
                                    ...area,
                                    blockIds: blockinfo?.blockIds ?? [],
                                },
                                entityType: 'area',
                                documentId: document.id,
                                uri: '/api/areas/' + area.id,
                                parentUri: '/api/document/' + document.id,
                                areaId: area.id,
                            }}
                            disabled={!area || !document}
                            icon={PencilSquare}
                            iconOnly={true}
                            tooltip={t('ai:sectionPreview.editAreaSettings')}
                        />
                    )}
                </div>
            </div>

            {area && <AreaEditsIcon area={area} />}

            <div className="ml-2">
                {!area?.properties?.isTemplate && (
                    <IconButton
                        size="lg"
                        icon={<FileEarmarkPreview size={20} />}
                        onClick={() => {
                            if (area) {
                                setSectionPreviewId(area.sectionId);
                            }
                        }}
                        tooltip={t('ai:sectionPreview.preview')}
                    />
                )}
            </div>

            {showHistorySidebarToggle && (
                <div className="position-relative flex-shrink-0">
                    <IconButton
                        size="lg"
                        icon={
                            <ClockHistory
                                className={cx({
                                    'text-primary': showHistorySidebar,
                                })}
                                size={20}
                            />
                        }
                        onClick={() => {
                            setShowHistorySidebar(!showHistorySidebar);
                            setSelectedHistoryVersion(undefined);
                        }}
                        tooltip={`title: ${t('documents:document.navbar.main.editor.left.blocks.tooltips.showHistoryVersions')}`}
                    />
                    {selectedHistoryVersion !== undefined && (
                        <CircleFill className="position-absolute" size={9} style={{ color: 'red', top: 0, right: 0 }} />
                    )}
                </div>
            )}
        </div>
    );
}
